import { render } from "./SelectBrands.vue?vue&type=template&id=3611d11c&scoped=true&ts=true"
import script from "./SelectBrands.vue?vue&type=script&lang=ts"
export * from "./SelectBrands.vue?vue&type=script&lang=ts"

import "./SelectBrands.vue?vue&type=style&index=0&id=3611d11c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3611d11c"]])

export default __exports__